import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Field, getFormValues } from 'redux-form';
import Answers from './Answers';
import FormCheckBoxWithLabel from '../legacyForm/FormCheckBoxWithLabel';
import VotingApprovals from './VotingApprovals';
import VoterIdentificationMethods from './VoterIdentificationMethods';
import { validateAnswers } from '../../models/budget/budgetSubmissionValidation';

const required = value => value ? undefined : 'Zgoda jest wymagana';
const validateForm = (form, props) => {
  const errors = validateAnswers(form, props);
  
  if (props.votingSettings.phoneVerificationEnabled
    && form.voter
    && form.voter.phoneNumber
    && /^\s*(\d\s*){9}$/.test(form.voter.phoneNumber)
    && (!form.phoneVerification || !form.phoneVerification.token)) {
    errors.voter = { phoneNumber: 'Numer telefonu musi zostać zweryfikowany' };
  }

  return errors;
};

const selector = formValueSelector('budgetVoteForm');

let BudgetVoteForm = ({
  handleSubmit,
  submitting,
  votingSettings,
  unit,
  disabled,
  approvalConstraintOption,
  onApprovalConstraintPick,
  change,
  actions,
  voterData,
  voterIdentificationMethodId,
  error,
  onSaveDraft,
  savingDraft,
  showSaveDraftButton,
  allValues,
  valid }) => {
  
  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <Answers votingSettings={votingSettings} error={error} disabled={disabled} />
      </div>
      <div className="row">
        <div className="box-header-outside">
          <div className="col-sm-12">
            <div className="header">
              <h2>Dane osoby głosującej</h2>
            </div>
          </div>
        </div>
        <div className="box">
          <div className="col-sm-12">
            <VoterIdentificationMethods
              voterIdentificationMethods={votingSettings.voterIdentificationMethods}
              change={change}
              voterIdentificationMethodId={voterIdentificationMethodId}
              actions={actions}
              voterData={voterData}
              customMessages={votingSettings.customMessages || {}}
              budgetId={votingSettings.id}
              requiresParentalConsent={votingSettings.requiresParentalConsent}
              parentalConsentAgeLimit={votingSettings.parentalConsentAgeLimit}
              disabled={disabled}
            />
            <div className="rodo" style={{ marginTop: 20, marginBottom: 20 }}>
              <div dangerouslySetInnerHTML={{ __html: unit.policy }} />
            </div>
            {votingSettings.predefinedApprovals.personalDataProcessing && <Field
              name="acceptPrivacyPolicy"
              component={FormCheckBoxWithLabel}
              label="Wyrażam zgodę na przetwarzanie moich danych osobowych dla potrzeb związanych z realizacją Budżetu"
              fullWidth
              validate={required}
              disabled={disabled}
            />}
            {votingSettings.predefinedApprovals.termsAndConditions && <Field
              name="acceptTerms"
              component={FormCheckBoxWithLabel}
              label={<div>Oświadczam, że zapoznałem/am się z treścią <a href="/regulamin" target="_blank" rel="noopener noreferrer">Regulaminu</a> oraz akceptuję jego postanowienia</div>}
              fullWidth
              validate={required}
              disabled={disabled}
            />}
            {votingSettings.approvals && votingSettings.approvals.length
              ? <VotingApprovals approvals={votingSettings.approvals} approvalConstraintOption={approvalConstraintOption} onApprovalConstraintPick={onApprovalConstraintPick} disabled={disabled} />
              : null}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12" style={{ marginRight: 15 }}>
          <button type="submit" disabled={submitting || disabled} className="btn btn-send">
            {submitting ? 'Zapisywanie...' : 'Oddaj głos'} <i className="fa fa-paper-plane" />
          </button>
          {showSaveDraftButton && (
            <button
              type="button"
              onClick={e => { 
                e.preventDefault();
                // Always call onSaveDraft to handle validation display
                onSaveDraft(allValues, valid); 
              }}
              disabled={savingDraft || disabled}
              className="btn btn-secondary"
              style={{ marginLeft: 10 }}
              aria-label="Zapisz wersję roboczą"
            >
              {savingDraft ? 'Zapisywanie...' : 'Zapisz wersję roboczą'}
            </button>
          )}
        </div>
      </div>
    </form>
  );
};

BudgetVoteForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  details: PropTypes.array,
  votingSettings: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  unit: PropTypes.object.isRequired,
  approvalConstraintOption: PropTypes.string,
  onApprovalConstraintPick: PropTypes.func,
  actions: PropTypes.object.isRequired,
  change: PropTypes.func.isRequired,
  error: PropTypes.string,
  voterData: PropTypes.object,
  voterIdentificationMethodId: PropTypes.string,
  onSaveDraft: PropTypes.func,
  savingDraft: PropTypes.bool,
  showSaveDraftButton: PropTypes.bool,
  allValues: PropTypes.object,
  valid: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    details: selector(state, 'details'),
    voterData: selector(state, 'voter'),
    voterIdentificationMethodId: selector(state, 'voterIdentificationMethodId'),
    allValues: getFormValues('budgetVoteForm')(state),
  };
}

BudgetVoteForm = reduxForm({
  form: 'budgetVoteForm',
  enableReinitialize: true,
  validate: validateForm,
})(BudgetVoteForm);

export default connect(mapStateToProps)(BudgetVoteForm);



// WEBPACK FOOTER //
// ./src/components/budget/BudgetVoteForm.js